module.exports = __webpack_public_path__ + "media/images/landing_page/banners/banner_one-8e6e893309abb9286e5ba1b1560555ca.jpg";